import illustrationUrl from '../assets/barbichette.svg';
import type { GameKind } from '../game/protocol';
import { h, mount } from './dom';

export const PRIVACY_NOTICE =
  "Ton visage est analysé uniquement dans ton navigateur. Tu choisis ce que ton ami voit : ta vidéo, envoyée en direct sans serveur, ou seulement ton maillage (ta vidéo ne sort alors jamais). Jamais de micro. Rien n'est enregistré.";

export function renderHome(
  root: HTMLElement,
  onChallenge?: (game: GameKind) => void,
  onSolo?: () => void,
  onDiagnostic?: () => void,
  onSmileySolo?: () => void,
): void {
  const challenge = (game: GameKind, testid: string, label: string): HTMLButtonElement => {
    const b = h('button', { type: 'button', class: 'button', testid }, label);
    b.addEventListener('click', () => onChallenge?.(game));
    return b;
  };
  const solo = h(
    'button',
    { type: 'button', class: 'button secondary', testid: 'solo' },
    'Jouer en solo',
  );
  if (onSolo) solo.addEventListener('click', onSolo);
  const smileySolo = h(
    'button',
    { type: 'button', class: 'button secondary', testid: 'solo-smiley' },
    'Imite ce smiley en solo',
  );
  if (onSmileySolo) smileySolo.addEventListener('click', onSmileySolo);
  const diagnostic = h(
    'button',
    { type: 'button', class: 'link-button', testid: 'diagnostic' },
    'Vérifier ma caméra et ma connexion',
  );
  if (onDiagnostic) diagnostic.addEventListener('click', onDiagnostic);
  mount(
    root,
    h('h1', { class: 'title' }, 'Barbichette'),
    h(
      'p',
      { class: 'intertitle' },
      '« Je te tiens, tu me tiens par la barbichette, le premier de nous deux qui rira aura une ',
      h('strong', {}, 'tapette'),
      ' ! »',
    ),
    h('img', {
      class: 'illustration',
      src: illustrationUrl,
      alt: 'Une main gantée pince une barbichette',
      width: '300',
      height: '240',
    }),
    h(
      'div',
      { class: 'actions' },
      challenge('barbichette', 'challenge', 'Barbichette avec un ami'),
      challenge('chifoumi', 'challenge-chifoumi', 'Chifoumi avec un ami'),
      challenge('smiley', 'challenge-smiley', 'Imite ce smiley avec un ami'),
      solo,
      smileySolo,
    ),
    diagnostic,
    h(
      'p',
      { class: 'privacy', testid: 'privacy' },
      h('span', { class: 'lock', 'aria-hidden': 'true' }),
      h('span', {}, PRIVACY_NOTICE),
    ),
  );
}
